import { creativeApi } from '../creativeApi'

export interface VideoPreviewParams {
  url: string
  duration?: number
  width?: number
  height?: number
  format?: 'mp4' | 'webm'
}

export interface CompositeVideoParams {
  url: string
  brand: string
  dateTime: string
  creativeDuration?: number
  width?: number
  height?: number
}

export const getPreviewVideo = async (params: VideoPreviewParams): Promise<Blob> => {
  const response = await creativeApi.get('/creative/preview/video', {
    params,
    responseType: 'blob',
  })

  return response.data
}

export const getCompositeVideo = async (params: CompositeVideoParams): Promise<Blob> => {
  const response = await creativeApi.get('/creative/composite/video', {
    params: {
      url: params.url,
      brand: params.brand,
      dateTime: params.dateTime,
      creativeDuration: params.creativeDuration,
      width: params.width,
      height: params.height,
    },
    responseType: 'blob',
  })

  return response.data
}

export const getBrands = async (): Promise<string[]> => {
  const response = await creativeApi.get('/creative/brands')

  return response.data?.brands ?? []
}
